import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';

const CartToast = (props) => {

    let cartItemCount = 0;
    let cartItemTotal = 0;
    let cart = localStorage.getItem('cartData');
    let cartData = JSON.parse(cart);
    //console.log(cart);
    //console.log(cartData);
    if(cart !== null && cart!=='{}')
    {
        Object.keys(cartData).forEach(function(key) {
            let Rate = 0;
            let itemTOTAL = 0;

            let cart_id = key.split('~~**~~');
            let itemID = cart_id[0];
            let itemCOUNT = cartData[key];
            let itemCUSTOM = cart_id[1];

            props.items.map(item=>{
                if(item.ITEMID==itemID)
                {
                    Rate = item.RATE;
                }
            })

            if(itemCUSTOM!='N')
            {
                let custom = itemCUSTOM.split('|');
                //console.log(custom);
                if(custom!='')
                {
                    custom.forEach(val => { 
                        let val2 = val.split('~');
                        Rate = parseFloat(Rate) + parseFloat(val2[3]);
                        //console.log(Rate);
                    });
                }
            }


            itemTOTAL = itemCOUNT * Rate;

            cartItemCount = cartItemCount + itemCOUNT;
            cartItemTotal = cartItemTotal + itemTOTAL;
        });    
    }

    let ToastCSS = cartItemCount!=0?' show':'';

    return (
        <div>
        {/*<div id="toast-6" className="carousel-button-footer">
            <div className="row">
                <div className="col-6">
                    <div className="text-muted">{cartItemCount!=0 && cartItemCount} Dishe{cartItemCount!=1?'s':''}</div>
                    <div className="text-price">&#8377; {cartItemTotal}</div>
                </div>
                <div className="col-6"> 
                    <Link to="/cart" className="btn btn-primary btn-lg btn-block"> CONFIRM</Link>
                </div>
            </div>
        </div>*/}
        <br /><br /><br />
        <div id="toast-5" className={`toast-box toast-bottom bottom-toast${ToastCSS}`}>
            <div className="in">
                <div className="text"> 
                    <div className="text-items">{cartItemCount!=0 && cartItemCount} Dish{cartItemCount!=1?'es':''}</div>
                    <div className="dish-price">&#8377; {cartItemTotal}</div>
                </div>
            </div>
            <Link to="/cart" className="btn btn-sm btn-text-primary"> CONFIRM</Link>
        </div>
        </div>
    );
}
  
export default CartToast;


// WEBPACK FOOTER //
// ./src/components/CartToast.js